<div class="row">

  <div class="col-12">
    <div class="minimenu-availability">
      <strong>MiniMenu service</strong>
      <span class="plan-chip">{{ isLoading ? 'Checking…' : loadFailed ? 'Unknown' : entitlement.plan }}</span>
      <span class="minimenu-hint minimenu-subscription-note" *ngIf="!isLoading && !loadFailed && !site?.isAvailable">
        Mini Menu needs a subscription. Please access EVOLUTION Marketplace through Subscriptions.
      </span>
    </div>
    <p class="minimenu-hint" *ngIf="isLoading">Checking MiniMenu availability...</p>
    <p class="minimenu-hint text-danger" *ngIf="loadFailed">
      MiniMenu availability could not be loaded. Please try opening this business again.
    </p>
  </div>

  <div class="col-12">
    <label class="data-label">Seeded Demo</label>
    <div class="d-flex align-items-center gap-1">
      <input class="form-control" [value]="seededDemoUrl" readonly />
      <a class="btn btn-outline-primary" [href]="seededDemoUrl" target="_blank" rel="noopener">Open</a>
    </div>
  </div>

  <div class="col-12 minimenu-body" *ngIf="!isLoading && !loadFailed && site?.isAvailable">
    <div class="row">

      <div class="col-12">
        <div class="minimenu-availability">
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" id="miniMenuPublishedSwitch"
                   [checked]="site?.isPublished" (change)="togglePublished($event)" [disabled]="isSaving" />
            <label class="form-check-label" for="miniMenuPublishedSwitch">
              {{ site?.isPublished ? 'Published' : 'Hidden' }}
            </label>
          </div>
          <span class="minimenu-hint" *ngIf="isSaving">Saving...</span>
        </div>
        <p class="minimenu-hint" *ngIf="!site?.isPublished">
          Publish MiniMenu to make the business link available to customers.
        </p>
      </div>

      <div class="col-sm-6">
        <label class="data-label">Public Menu Link</label>
        <input class="form-control" [value]="publicMenuUrl" readonly />
      </div>
      <div class="col-sm-6">
        <label class="data-label">Published Branch</label>
        <input class="form-control" [value]="publishedBranchTitle || '-'" readonly />
      </div>

      <div class="col-12" *ngIf="site?.isPublished && publicMenuUrl">
        <a class="btn btn-outline-primary" [href]="publicMenuUrl" target="_blank" rel="noopener">Open Public MiniMenu</a>
      </div>

      <!-- Poster artwork is downloadable, not stored, so this is available as soon as the
           public link exists — publishing can come after the printing. Given its own heading
           because without one it reads as a footnote to the link above and gets skipped. -->
      <div class="col-12" *ngIf="publicMenuUrl">
        <h5 class="minimenu-subtitle">Promotion Poster Setup</h5>
        <p class="minimenu-hint">
          Print-ready poster artwork built around the QR code that opens this menu — pick a size
          and layout, add your photo and offer, then download the overlay.
        </p>
        <button type="button" class="btn btn-outline-primary minimenu-poster-btn"
                (click)="openQrPosterModal()">
          Set up QR posters
        </button>
      </div>

      <!-- No umbrella "Mini Menu Details" heading: it was introduced to caption a "Coming soon"
           callout, and once these settings became editable the callout went and the heading had
           nothing under it. Landing / Appearance / Languages / What's On stand on their own. -->
      <div class="col-12 minimenu-future-settings">
          <div class="row">

      <!-- Landing -->
      <div class="col-12">
        <h5 class="minimenu-subtitle">Landing</h5>
      </div>
      <div class="col-sm-6">
        <app-input [inputType]="'text'" [fieldValue]="settings.locationTag" [fieldText]="'locationTag'"
                   [fControl]="formGroup.controls['LocationTag']" [inputClass]="'form-control'"
                   [inputPlaceholder]="'Enter Location Tag'" [inputLabel]="'Location Tag'" [labelClass]="'data-label'"
                   [isRequired]="false"
                   [maxLengthValidationMsg]="'Location Tag must be at most 24 characters long.'"
                   (keydown.enter)="$event.preventDefault()"></app-input>
      </div>
      <div class="col-sm-6">
        <app-input [inputType]="'text'" [fieldValue]="settings.eyebrow" [fieldText]="'eyebrow'"
                   [fControl]="formGroup.controls['Eyebrow']" [inputClass]="'form-control'"
                   [inputPlaceholder]="'Enter Tagline'" [inputLabel]="'Tagline'" [labelClass]="'data-label'"
                   [isRequired]="false" (keydown.enter)="$event.preventDefault()"></app-input>
      </div>
      <div class="col-12">
        <label class="data-label">Welcome Message</label>
        <textarea class="form-control textarea-cnt" [formControl]="formGroup.controls['Subline']"
                  placeholder="Enter Welcome Message"></textarea>
      </div>
      <div class="col-sm-6 col-md-4">
        <label class="data-label">Landing Background</label>
        <div class="file-upload-wrap" *ngIf="!settings.teaserBackgroundUrl">
          <input #teaserInput type="file" accept="image/*" [disabled]="isSaving" (change)="onImageSelected($event, 'teaserBackgroundUrl')"
                 (click)="teaserInput.value = ''" />
          <div class="upload-inner">
            <img src="./assets/images/ic-add.svg" alt="Add Icon" class="add-icon" (click)="teaserInput.click()" />
            <span>ADD PHOTO</span>
          </div>
        </div>
        <div class="minimenu-image-preview" *ngIf="settings.teaserBackgroundUrl">
          <img [src]="settings.teaserBackgroundUrl" alt="Landing background" />
          <span class="close-span" title="Remove" (click)="clearImage('teaserBackgroundUrl')"></span>
        </div>
        <button type="button" class="minimenu-crop-link" *ngIf="settings.teaserBackgroundUrl"
                [disabled]="isSaving" (click)="editLandingCrops()">
          Adjust device crops
        </button>
      </div>
      <!-- Logos are not part of this phase: blurred out and inert, with the reason on hover. -->
      <div class="col-sm-6 col-md-4">
        <label class="data-label">Landing Logo</label>
        <div class="minimenu-locked" ngbTooltip="Coming Soon" tooltipClass="tooltip-custom"
             placement="top" aria-disabled="true">
          <div class="minimenu-locked-inner">
            <div class="file-upload-wrap">
              <div class="upload-inner">
                <img src="./assets/images/ic-add.svg" alt="" class="add-icon" />
                <span>ADD PHOTO</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-4">
        <label class="data-label">Header Logo</label>
        <div class="minimenu-locked" ngbTooltip="Coming Soon" tooltipClass="tooltip-custom"
             placement="top" aria-disabled="true">
          <div class="minimenu-locked-inner">
            <div class="file-upload-wrap">
              <div class="upload-inner">
                <img src="./assets/images/ic-add.svg" alt="" class="add-icon" />
                <span>ADD PHOTO</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Appearance: shown as the chosen characteristics rather than raw fields. -->
      <div class="col-12">
        <h5 class="minimenu-subtitle">Appearance</h5>
      </div>
      <div class="col-12">
        <div class="minimenu-appearance-card" [style.font-family]="themeFontStack"
             [style.background-color]="settings.theme.backgroundColor"
             [style.color]="settings.theme.contentColor">
          <button type="button" class="appearance-edit text-uppercase" title="Edit appearance"
                  (click)="openAppearanceModal()">
            Edit
          </button>
          <div class="appearance-specimen">
            <span class="specimen-mark" [style.background-color]="settings.theme.uiColor"
                  [style.color]="settings.theme.backgroundColor">Aa</span>
            <div class="specimen-copy">
              <span class="specimen-eyebrow" [style.color]="settings.theme.accentColor">
                {{ settings.eyebrow || 'Digital menu' }}
              </span>
              <strong class="specimen-name">{{ businessDetails?.name || 'Your Business' }}</strong>
              <span class="specimen-font">{{ fontSelect.title }}</span>
            </div>
          </div>
          <ul class="appearance-swatches">
            <li><span class="swatch" [style.background-color]="settings.theme.backgroundColor"></span>
              <span class="swatch-label">Background</span><span class="swatch-hex">{{ settings.theme.backgroundColor }}</span></li>
            <li><span class="swatch" [style.background-color]="settings.theme.uiColor"></span>
              <span class="swatch-label">Interface</span><span class="swatch-hex">{{ settings.theme.uiColor }}</span></li>
            <li><span class="swatch" [style.background-color]="settings.theme.contentColor"></span>
              <span class="swatch-label">Content Text</span><span class="swatch-hex">{{ settings.theme.contentColor }}</span></li>
            <li><span class="swatch" [style.background-color]="settings.theme.accentColor"></span>
              <span class="swatch-label">Accent</span><span class="swatch-hex">{{ settings.theme.accentColor }}</span></li>
          </ul>
        </div>
      </div>

      <!-- Languages -->
      <div class="col-12">
        <h5 class="minimenu-subtitle">Languages</h5>
      </div>
      <div class="col-sm-6">
        <app-select [options]="languages" [selectClass]="'ng-form-select primary-select'"
                    selectPlaceholder="Select Language" label="Default Language" [selectedValue]="languageSelect"
                    (selectedValueChange)="onLanguageChange($event)"></app-select>
      </div>
      <div class="col-sm-6 minimenu-lang-check">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="miniMenuChineseCheck"
                 [(ngModel)]="settings.chineseEnabled" [ngModelOptions]="{standalone: true}" />
          <label class="form-check-label" for="miniMenuChineseCheck">Offer Chinese menu</label>
        </div>
      </div>

      <!-- Translations -->
      <ng-container *ngIf="settings.chineseEnabled">
        <div class="col-12">
          <h5 class="minimenu-subtitle">Chinese Translations</h5>
          <p class="minimenu-hint">Blank translations fall back to the original Evolution text.</p>
        </div>
        <div class="col-sm-6">
          <label class="data-label">Location Tag / ZH.CN</label>
          <input class="form-control" [(ngModel)]="translation.site.locationTag"
                 [ngModelOptions]="{standalone: true}" />
        </div>
        <div class="col-sm-6">
          <label class="data-label">Tagline / ZH.CN</label>
          <input class="form-control" [(ngModel)]="translation.site.eyebrow"
                 [ngModelOptions]="{standalone: true}" />
        </div>
        <div class="col-12">
          <label class="data-label">Welcome Message / ZH.CN</label>
          <textarea class="form-control textarea-cnt" [(ngModel)]="translation.site.subline"
                    [ngModelOptions]="{standalone: true}"></textarea>
        </div>

        <div class="col-12" *ngFor="let category of site?.menu">
          <div class="minimenu-translation-card">
            <h6>{{category.title}}</h6>
            <label class="data-label">Category Name / ZH.CN</label>
            <input class="form-control" [(ngModel)]="menuTranslation(1, category.id).name"
                   [ngModelOptions]="{standalone: true}" />

            <div class="minimenu-translation-product" *ngFor="let product of category.products">
              <strong>{{product.title}}</strong>
              <label class="data-label">Product Name / ZH.CN</label>
              <input class="form-control" [(ngModel)]="menuTranslation(2, product.id).name"
                     [ngModelOptions]="{standalone: true}" />
              <label class="data-label">Description / ZH.CN</label>
              <textarea class="form-control textarea-cnt"
                        [(ngModel)]="menuTranslation(2, product.id).description"
                        [ngModelOptions]="{standalone: true}"></textarea>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- What's On — the restaurant's own promotions. Foodie News is office-sourced and
           deliberately not selectable here. -->
      <div class="col-12">
        <h5 class="minimenu-subtitle with-count">
          What's On <span class="count">({{settings.promos.length}} promos)</span>
        </h5>
        <p class="minimenu-hint">
          Write your own promotions. Each one is saved as a draft first, then reviewed by HUNGERY
          before it appears on your public menu and business listing. Once published, you can request
          a separate placement in Foodie News on the HUNGERY homepage.
        </p>
      </div>

      <div class="col-12" *ngFor="let promo of settings.promos; let i=index">
        <div class="minimenu-promo-summary" [class.is-inactive]="promo.status === 'suspended' || promo.status === 'deleted'">
          <div class="promo-thumb" [class.no-thumb]="!promoThumb(promo)">
            <img *ngIf="promoThumb(promo)" [src]="promoThumb(promo)" alt="Promo image" />
            <span *ngIf="!promoThumb(promo)">No image</span>
          </div>
          <div class="promo-info">
            <div class="promo-badge-row" *ngIf="promo.badge">
              <span class="promo-badge">{{promo.badge}}</span>
            </div>
            <h6 class="promo-title">{{promo.title || 'Untitled promotion'}}</h6>
            <p class="promo-when" *ngIf="promo.when">{{promo.when}}</p>
            <p class="promo-lead" *ngIf="promo.lead">{{promo.lead}}</p>
            <div class="homepage-placement" *ngIf="promo.homepageStatus">
              <strong>{{homepageStatusLabel(promo)}}</strong>
              <span *ngIf="promo.homepageStatus === 2 && promo.homepageExpiresOn">
                Until {{promo.homepageExpiresOn | date:'medium'}}
              </span>
              <span *ngIf="promo.homepageReviewNotes">{{promo.homepageReviewNotes}}</span>
            </div>
          </div>

          <!-- Status lives in the card's top-right corner rather than inline with the badge:
               anchored there it cannot be shifted around by a badge like "Now Pouring". -->
          <div class="promo-status-corner">
            <span class="promo-status-note" *ngIf="promoNote(promo)">{{promoNote(promo)}}</span>

            <!-- Kept in-place rather than container="body": the menu has to stay inside the
                 component so its scoped styles apply. Anchored at the right edge, so the
                 placement list prefers the end-aligned options. -->
            <div ngbDropdown class="promo-status-dropdown"
                 placement="bottom-end bottom-start top-end top-start">
              <button type="button" class="promo-status-chip" [ngClass]="'is-' + promo.status"
                      ngbDropdownToggle [disabled]="promoBusyId !== null || promo.isLegacy"
                      [title]="'Promotion actions'">
                {{promoStatusLabel(promo)}}
              </button>

              <!-- Actions only. Anything explanatory lives in the note beside the pill, so the
                   popup stays one short list of choices. -->
              <div ngbDropdownMenu class="promo-status-menu">
                <button type="button" ngbDropdownItem
                        *ngIf="promo.status !== 'suspended' && promo.status !== 'deleted'"
                        (click)="openPromoModal(promo, i)">Edit</button>

                <button type="button" ngbDropdownItem *ngIf="promo.status === 'draft'"
                        (click)="submitForReview(promo)">
                  Submit for review
                </button>

                <button type="button" ngbDropdownItem *ngIf="promo.status === 'review'"
                        [disabled]="!canResubmit(promo)" [title]="promoNote(promo)"
                        (click)="openResubmitPrompt(promo)">
                  Re-submit review
                </button>

                <button type="button" ngbDropdownItem *ngIf="canRequestHomepage(promo)"
                        [disabled]="isSaving" (click)="openHomepageRequest(promo)">
                  Request homepage placement
                </button>

                <button type="button" ngbDropdownItem
                        *ngIf="promo.status === 'live' || promo.status === 'promoted'"
                        (click)="openSuspendPrompt(promo)">
                  Suspend
                </button>

                <button type="button" ngbDropdownItem *ngIf="promo.status === 'suspended'"
                        (click)="restorePromo(promo)">
                  Publish again
                </button>

                <button type="button" ngbDropdownItem *ngIf="canRestoreDeleted(promo)"
                        (click)="restorePromo(promo)">
                  Restore
                </button>

                <button type="button" ngbDropdownItem class="promo-menu-delete"
                        *ngIf="promo.status !== 'deleted'" (click)="openDeletePrompt(promo, i)">
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="minimenu-translation-card" *ngIf="settings.chineseEnabled">
          <h6>{{promo.title}} / ZH.CN</h6>
          <div class="row">
            <div class="col-sm-6">
              <label class="data-label">Badge</label>
              <input class="form-control" [(ngModel)]="promoTranslation(promo.promotionId).badge"
                     [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="col-sm-6">
              <label class="data-label">Title</label>
              <input class="form-control" [(ngModel)]="promoTranslation(promo.promotionId).title"
                     [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="col-sm-6">
              <label class="data-label">When</label>
              <input class="form-control" [(ngModel)]="promoTranslation(promo.promotionId).availabilityText"
                     [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="col-sm-6">
              <label class="data-label">Lead</label>
              <input class="form-control" [(ngModel)]="promoTranslation(promo.promotionId).lead"
                     [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="col-12">
              <label class="data-label">Body</label>
              <textarea class="form-control textarea-cnt"
                        [(ngModel)]="promoTranslation(promo.promotionId).body"
                        [ngModelOptions]="{standalone: true}"></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <p class="text-center no-record-found-text minimenu-empty" *ngIf="!settings.promos.length">
          No promotions yet.
        </p>
        <button type="button" class="btn btn-text btn-add-item text-uppercase minimenu-add-promo"
                (click)="addPromotion()">
          <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M9 5.40046L9 3.60046L5.40039 3.60046L5.40039 0.000243983L3.60039 0.000243905L3.60039 3.60046L-1.57371e-07 3.60046L-2.36051e-07 5.40046L3.60039 5.40046L3.60039 9.00024L5.40039 9.00024L5.40039 5.40046L9 5.40046Z"
                  fill="currentcolor" />
          </svg>
          Add Promotion
        </button>
      </div>

      <!-- No save button of its own: the page's Cancel Edits / Save Details bar owns saving, and
           OnboardingComponent.saveBusinessDetails() calls this component's save(). -->

          </div>
      </div>

    </div>
  </div>
</div>

<!-- Promotion lifecycle prompts. Same warning-section-modal design as the business
     "Publish business?" confirm, so submitting a promotion reads the same as publishing a
     business for the first time. -->

<ng-template #promoSubmitModal let-modal>
  <div class="modal-head">
    <button class="btn btn-close" (click)="modal.close('Close click')"></button>
  </div>
  <div class="modal-body">
    <div class="img-wrap">
      <img src="./assets/images/ic-confirmation.svg" alt="Icon">
    </div>
    <h2 class="title-text" ngbAutofocus>Submit promotion for review?</h2>
    <h5 class="info-text">
      Your MiniMenu details are saved. You have {{submittableDrafts().length}} draft promotion(s).
      Submitting sends them to HUNGERY for approval — they appear on your public menu and business
      listing once approved. You can keep them as drafts instead.
    </h5>
    <div class="btn-grps">
      <button class="btn btn-primary" title="Submit for review"
              (click)="modal.close('Close click'); confirmSubmitDrafts();">Submit for review</button>
      <button class="btn btn-outline-primary" title="Keep as draft"
              (click)="modal.close('Close click')">Keep as draft</button>
    </div>
  </div>
</ng-template>

<ng-template #promoResubmitModal let-modal>
  <div class="modal-head">
    <button class="btn btn-close" (click)="modal.close('Close click')"></button>
  </div>
  <div class="modal-body">
    <div class="img-wrap">
      <img src="./assets/images/ic-confirmation.svg" alt="Icon">
    </div>
    <h2 class="title-text" ngbAutofocus>Re-submit for review?</h2>
    <h5 class="info-text">
      "{{promoInFlight?.title || 'This promotion'}}" has been waiting
      {{reviewWaitingDays(promoInFlight) }} working days for approval. Re-submitting puts it back
      at the front of the review queue.
    </h5>
    <div class="btn-grps">
      <button class="btn btn-primary" title="Re-submit review"
              (click)="modal.close('Close click'); confirmResubmit();">Re-submit review</button>
      <button class="btn btn-outline-primary" title="Keep waiting"
              (click)="modal.close('Close click')">Keep waiting</button>
    </div>
  </div>
</ng-template>

<ng-template #promoSuspendModal let-modal>
  <div class="modal-head">
    <button class="btn btn-close" (click)="modal.close('Close click')"></button>
  </div>
  <div class="modal-body">
    <div class="img-wrap">
      <img src="./assets/images/ic-confirmation.svg" alt="Icon">
    </div>
    <h2 class="title-text" ngbAutofocus>Suspend promotion?</h2>
    <h5 class="info-text">
      "{{promoInFlight?.title || 'This promotion'}}" stops showing on your public menu for
      {{promoRules.suspendDays}} days. After that you will be asked to publish it again or delete it.
    </h5>
    <div class="btn-grps">
      <button class="btn btn-primary" title="Suspend"
              (click)="modal.close('Close click'); confirmSuspend();">Suspend</button>
      <button class="btn btn-outline-primary" title="Cancel"
              (click)="modal.close('Close click')">Cancel</button>
    </div>
  </div>
</ng-template>

<ng-template #promoDeleteModal let-modal>
  <div class="modal-head">
    <button class="btn btn-close" (click)="modal.close('Close click')"></button>
  </div>
  <div class="modal-body">
    <div class="img-wrap">
      <img src="./assets/images/ic-confirmation.svg" alt="Icon">
    </div>
    <h2 class="title-text" ngbAutofocus>Delete promotion?</h2>
    <h5 class="info-text">
      "{{promoInFlight?.title || 'This promotion'}}" is removed from your public menu straight away.
      You can restore it for {{promoRules.deleteRestoreDays}} days; after
      {{promoRules.deletePurgeDays}} days it is deleted permanently and cannot be recovered.
    </h5>
    <div class="btn-grps">
      <button class="btn btn-danger" title="Delete"
              (click)="modal.close('Close click'); confirmDelete();">Delete</button>
      <button class="btn btn-outline-primary" title="Cancel"
              (click)="modal.close('Close click')">Cancel</button>
    </div>
  </div>
</ng-template>

<!-- Not dismissible: a suspension that has run out has to be resolved one way or the other,
     so the storage is not held open indefinitely. -->
<ng-template #promoSuspensionExpiredModal let-modal>
  <div class="modal-body">
    <div class="img-wrap">
      <img src="./assets/images/ic-confirmation.svg" alt="Icon">
    </div>
    <h2 class="title-text" ngbAutofocus>Publish or delete this promotion?</h2>
    <h5 class="info-text">
      "{{promoInFlight?.title || 'This promotion'}}" has been suspended for more than
      {{promoRules.suspendDays}} days. Publish it again to send it back for review, or delete it to
      free up the space. This has to be decided before you continue.
    </h5>
    <div class="btn-grps">
      <button class="btn btn-primary" title="Publish again"
              (click)="modal.close('Close click'); restorePromo(promoInFlight);">Publish again</button>
      <button class="btn btn-danger" title="Delete"
              (click)="modal.close('Close click'); confirmDelete();">Delete</button>
    </div>
  </div>
</ng-template>

<ng-template #homepageRequestModal let-modal>
  <div class="modal-head">
    <button type="button" class="btn btn-close" aria-label="Close"
            [disabled]="promoBusyId !== null" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body homepage-request" *ngIf="homepagePromo as promo">
    <h2 id="homepage-request-title" class="title-text" ngbAutofocus>Request homepage placement</h2>
    <p>Send this What's On post for review to appear in Foodie News on the HUNGERY homepage.
      The reviewer will set its visibility expiration when approving it.</p>
    <article class="homepage-preview">
      <img *ngIf="promoThumb(promo)" [src]="promoThumb(promo)" [alt]="promo.title" />
      <div>
        <span *ngIf="promo.badge" class="promo-badge">{{promo.badge}}</span>
        <h3>{{promo.title}}</h3>
        <p *ngIf="promo.when">{{promo.when}}</p>
        <p *ngIf="promo.lead"><strong>{{promo.lead}}</strong></p>
        <div class="homepage-preview-body" [innerHTML]="promo.body"></div>
      </div>
    </article>
    <label class="data-label" for="homepage-request-notes">Notes for the reviewer (optional)</label>
    <textarea id="homepage-request-notes" class="form-control" rows="3" maxlength="1000"
              [(ngModel)]="homepageRequestNotes" [ngModelOptions]="{standalone: true}"
              [disabled]="promoBusyId !== null"></textarea>
    <p class="homepage-request-error" role="alert" *ngIf="homepageRequestError">{{homepageRequestError}}</p>
    <p *ngIf="!canRequestHomepage(promo)">{{homepageStatusLabel(promo) || 'This post is no longer eligible for homepage placement.'}}</p>
    <div class="btn-grps homepage-request-actions">
      <button type="button" class="btn btn-primary" (click)="confirmHomepageRequest()"
              [disabled]="promoBusyId !== null || isSaving || !canRequestHomepage(promo) || homepageRequestNotes.length > 1000">
        {{promoBusyId !== null ? 'Submitting...' : 'Submit request'}}
      </button>
      <button type="button" class="btn btn-outline-primary" (click)="modal.dismiss()" [disabled]="promoBusyId !== null">Cancel</button>
    </div>
  </div>
</ng-template>
